<template>
  <b-badge
    qa="status-badge"
    class="state-badge"
    pill
    :class="statusClass"
  >
    {{ status.name }}
  </b-badge>
</template>

<script>

import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'

export default {
    name: 'CommonSampleStatusBadge',
    props: {
        status: { type: Object, required: true }
    },
    data() {
        return {
            invalidStatus: { bgColor: 'red', color: 'white', name: 'global.statusOptions.invalid' }
        }
    },
    computed: {
        statusClass() {
            return this.statusOption.class
        },
        statusOption() {
            return Object.values(SAMPLE_STATES).find((state) => state.code === this.status.code) ||
                this.invalidStatus
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
    min-width: 85px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
